/**
 * Remote Config `enrollment_brand_ids_web` is a JSON array string (e.g. `["261","affiliate-38"]`).
 * Invalid entries are passed through; Constructor ignores bad item ids.
 */
export function parseEnrollPreviewBrandIdsFromRemoteConfig(
    raw: string | undefined | null
): string[] {
    if (raw == null || typeof raw !== 'string') {
        return [];
    }

    const trimmed = raw.trim();
    if (!trimmed) {
        return [];
    }

    try {
        const parsed = JSON.parse(trimmed) as unknown;
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed.map((x) => String(x)).filter(Boolean);
    } catch {
        return [];
    }
}
